import { useMutation } from "@tanstack/react-query"

import { WindowsCursorsApi } from "../../api/WindowsCursorsApi"

import type { ConversionError, RateLimitError } from "../../api/WindowsCursorsApi.errors"
import type {
  CreateWindowsCursorParams,
  WindowsCursorFile,
} from "../../api/WindowsCursorsApi.types"

// Nothing is stored server-side, so there is no query to invalidate.
export const useCreateWindowsCursor = () => {
  return useMutation<
    WindowsCursorFile,
    ConversionError | RateLimitError | Error,
    CreateWindowsCursorParams
  >({
    mutationFn: WindowsCursorsApi.create,
  })
}
